import * as React from "react"
import {FooterBottomLink} from './FooterBottomLink'
import { Route, RoutesOutput, User } from "../../../types/types";
import { SignOut } from "../../../api/auth";
import { Popup } from "../modals/Popup";
import NewsletterSignupForm from "../forms/NewsletterSignupForm";

interface FooterBottomState {
  showNewsletterPopup: "closed" | "open" | "success"
};

export type BottomFooterRoutes = {
  advertise_url: Route,
  about_url: Route,
  destroy_user_session_url?: Route
  disclaimer_url: Route,
  terms_and_conditions_url: Route,
  new_newsletter_url: Route,
  superadmin_root_url?: Route,
  admin_user_adverts_url?: Route,
  edit_user_url?: Route,
  new_user_session_url?: Route,
  new_user_registration_url?: Route,
}

type Props = {
  routes: RoutesOutput<BottomFooterRoutes>
  current_user: User
  recaptcha_key: string
}

export class FooterBottom extends React.Component<Props, FooterBottomState> {

  constructor(props:Props) {
    super(props);
    this.state = {
      showNewsletterPopup: "closed"
    }
  }

  componentDidUpdate(_:Props, prevState: FooterBottomState) {
    if (this.state.showNewsletterPopup == "success" && prevState.showNewsletterPopup != "success") {
      setTimeout(() => {
        this.setState({...this.state, showNewsletterPopup: "closed"})
      }, 5000);
    }
  }

  public render(): JSX.Element {
    return (

      <div className="subfooter">
        <div className="grid-container">
        <div className="subfooter__inner">
            <FooterBottomLink
              href={this.props.routes.get('advertise_url').path}
              title={I18n.t("advertise.menu-title")}
            />

            {this.props.current_user === null ?
              <FooterBottomLink
                href={this.props.routes.get('new_user_registration_url').path}
                title={I18n.t("sessions.links.register")}
              />
            :
              <>
                {this.props.current_user.role == "user" ?
                  <FooterBottomLink
                    href={this.props.routes.get('admin_user_adverts_url').path}
                    title={I18n.t("advertise.menu-title")}
                    className="icon-house"
                  />
                :  this.props.current_user.role == "admin" ?
                  <FooterBottomLink
                    href={this.props.routes.get('superadmin_root_url').path}
                    title={I18n.t("admin.menu.superadmin")}
                    className="icon-advert"
                  />
                :
                  <FooterBottomLink
                    href={this.props.routes.get('edit_user_url').path}
                    title={I18n.t("advertise.menu-title")}
                    className="icon-house"
                  />
              }

              </>
            }
            <FooterBottomLink
              href={this.props.routes.get('about_url').path}
              title={I18n.t("about.footer.link")}
            />
            <FooterBottomLink
              href={I18n.t("pages.handles.gites_guarantee.url")}
              title={I18n.t("pages.handles.gites_guarantee.title")}
            />

            <FooterBottomLink
              href={this.props.routes.get('disclaimer_url').path}
              title={I18n.t("pages.handles.disclaimer")}
            />
            <FooterBottomLink
              href={this.props.routes.get('terms_and_conditions_url').path}
              title={I18n.t("pages.handles.terms_and_conditions")}
            />
            <FooterBottomLink
              onClick={() => {
                this.setState({...this.state, showNewsletterPopup: "open"})
              }}
              href="#"
              title={I18n.t("footer.newsletter.button")}
              className="icon-mail"
            />

            {
              this.state.showNewsletterPopup == "open" ?
                <Popup close={() => this.setState({...this.state, showNewsletterPopup: "closed"})}>
                  <div className="popup-body">
                    <NewsletterSignupForm
                      recaptchakey={this.props.recaptcha_key}
                      onFinish={() => this.setState({...this.state, showNewsletterPopup: "success"})}
                      onCancel={() => this.setState({...this.state, showNewsletterPopup: "closed"})}
                    />
                  </div>
                </Popup>
              : this.state.showNewsletterPopup == "success" ?
                <Popup close={() => this.setState({...this.state, showNewsletterPopup: "closed"})}>
                  <div className="popup-body">
                    {I18n.t("form_newsletter_subscribes.crud.created")}
                  </div>
                </Popup>
              : ''
            }
          </div>
        </div>
      </div>
    );
  }
}
